import http from './helpers/httpInterceptor'

const state = () => ({
    jobInfo: [],
    jobInfoUpdate: [],
    jobInfoList: [],
    maxDate: [],
    jobInfoDelete: [],
});

// mutations
const mutations = {
    LIST_JOB_INFO(states, data) {
        states.jobInfoList = data;
    },
    MAX_DATE(states, data) {
        states.maxDate = data;
    },
    ADD_NEW_JOB_INFO(states, data) {
        states.jobInfo = data
    },
    UPDATE_JOB_INFO(states, data) {
        states.jobInfoUpdate = data
    },
    DELETE_JOB_INFO(states, data) {
        states.jobInfoDelete = data
    }
};

// actions
const actions = {
    getAllJobInfo({ commit }, payload) {
        return http
            .get("tms/job-info-history/get-all" + payload)
            .then((res) => {
                commit("LIST_JOB_INFO", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },


    filterJobInfo({ commit }, payload) {
        return http
            .get("/tms/job_info/employee?employeeId=" + payload[0])
            .then((res) => {
                commit("LIST_JOB_INFO", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },

    createJobInfo({ commit }, payload) {
        return http
            .post("tms/job-info-history/create-job-info-history", payload)
            .then((res) => {
                commit("ADD_NEW_JOB_INFO", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },

    updateJobInfo({ commit }, payload) {
        return http
            .put("/tms/job-info-history/update-job-info-history" , payload)
            .then((res) => {
                commit("UPDATE_JOB_INFO", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },

    removeJobInfo({ commit }, id) {
        return http
            .delete("/tms/job_info/id?id=" + id)
            .then((res) => {
                commit("DELETE_JOB_INFO", res.data);
                return res.data;
            })
            .catch((error) => {
                throw (error)
            });
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};